import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppShell } from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import MenuPage from "./pages/MenuPage";
import AdminPage from "./pages/AdminPage";
import MaintenancePage from "./pages/MaintenancePage";
import ServiziPage from "./pages/ServiziPage";
import LinkPage from "./pages/LinkPage";
import InstallPage from "./pages/InstallPage";
import AnalisiPage from "./pages/AnalisiPage";
import MonitorPage from "./pages/MonitorPage";
import MonitorAppPage from "./pages/MonitorAppPage";
import MonitorSitiPage from "./pages/MonitorSitiPage";
import MarketingPage from "./pages/MarketingPage";
import MarketingEmailPage from "./pages/MarketingEmailPage";
import MarketingTemplatePage from "./pages/MarketingTemplatePage";
import MarketingListePage from "./pages/MarketingListePage";
import MarketingDatabasePage from "./pages/MarketingDatabasePage";
import MarketingGoogleAdsPage from "./pages/MarketingGoogleAdsPage";
import MarketingSocialPage from "./pages/MarketingSocialPage";
import MarketingCalendarPage from "./pages/MarketingCalendarPage";
import MarketingToolsPage from "./pages/MarketingToolsPage";
import MarketingStatsPage from "./pages/MarketingStatsPage";
import MarketingAutomationsPage from "./pages/MarketingAutomationsPage";
import MarketingWhatsAppPage from "./pages/MarketingWhatsAppPage";
import MarketingIniziativePage from "./pages/MarketingIniziativePage";
import MarketingIniziativaSitoPage from "./pages/MarketingIniziativaSitoPage";
import VikiPage from "./pages/VikiPage";
import VikiStandalonePage from "./pages/VikiStandalonePage";
import SettingsPage from "./pages/SettingsPage";
import { AREA_URLS } from "./config/areaUrls";

function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);
  return <div className="min-h-screen bg-canvas" data-testid="external-redirect" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/viki-app" element={<VikiStandalonePage />} />
          <Route
            path="/menu"
            element={
              <ProtectedRoute>
                <AppShell><MenuPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route path="/web" element={<Navigate to="/monitor/siti" replace />} />
          <Route path="/webapp" element={<Navigate to="/monitor/app" replace />} />
          <Route
            path="/analisi"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><AnalisiPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route path="/mercato" element={<Navigate to="/analisi" replace />} />
          <Route
            path="/monitor"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MonitorPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/app"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MonitorAppPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/siti"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MonitorSitiPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingEmailPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/iniziative"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingIniziativePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/iniziative/:site"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingIniziativaSitoPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email/template"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingTemplatePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email/liste"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingListePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email/database"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingDatabasePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/googleads"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingGoogleAdsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/social"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingSocialPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/social/calendario"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingCalendarPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/strumenti"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingToolsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email/statistiche"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingStatsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/email/automazioni"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingAutomationsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing/whatsapp"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MarketingWhatsAppPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/viki"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><VikiPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scarica"
            element={
              <ProtectedRoute>
                <AppShell><InstallPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AppShell><AdminPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/manutenzione"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><MaintenancePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/impostazioni/servizi"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><ServiziPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route path="/manutenzione/servizi" element={<Navigate to="/impostazioni/servizi" replace />} />
          <Route
            path="/impostazioni"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><SettingsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/link"
            element={
              <ProtectedRoute masterOnly>
                <AppShell><LinkPage /></AppShell>
              </ProtectedRoute>
            }
          />
          {Object.entries(AREA_URLS).map(([key, url]) => (
            <Route key={key} path={`/${key}`} element={<ExternalRedirect url={url} />} />
          ))}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
